import { DocumentMaster } from "./DocumentMaster.model";
import { McqMaster } from "./McqMaster.model";

export class MCQOptionMaster{
    public mcqOptionMasterId: number;
    public mcqMaster: McqMaster;
    public optionDocumentMaster: DocumentMaster;
    public optionDocumentMasterId: number;
    public isActualAnswer: boolean;
    public answerContentMasterId: number;

    public isCompleted: boolean;
    public selected: boolean;
    public wrongAnswer: boolean;
    public rightAnswer: boolean;

}